var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('DashboardMobile',{attrs:{"items":_vm.menuItems}}),_c('DashboardDesktop',{attrs:{"items":_vm.menuItems}}),_c('div',{staticClass:"col-lg-10 d-lg-block"},[_vm._t("default")],2)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }